// Centralised resolver for build-time configuration injected via Vite.
//
// All values come from `import.meta.env.VITE_*` (set in `.env.development`,
// `.env.production`, or in CI). This module is the only place we tolerate
// fallbacks — every other module imports the resolved constants from here so
// the rest of the app never sees a process-vs-import.meta split.

function clean(value: string | undefined, fallback: string): string {
  const trimmed = (value ?? "").trim();
  return trimmed ? trimmed.replace(/\/+$/, "") : fallback;
}

/**
 * Base URL for all API requests, including the trailing `/api` segment.
 * Examples:
 *   - dev:  http://localhost:8000/api
 *   - prod: https://api.criterion.highbrowtechnology.com/api
 */
export const API_BASE_URL = clean(
  import.meta.env.VITE_API_BASE_URL,
  "http://localhost:8000/api",
);
